import { NavLink, useParams } from "react-router";
import { ReactNode, useCallback, useState } from "react";
import t from "@/lang/lang";
import { NewCertificateButton } from "@/services/backend/rlt/certificates/components/new-certificate-button";
import {
  MilestonePage,
  MilestonePageContent,
  MilestonePageHeader,
  MilestonePageTitle,
} from "@/shared/bsm/core/milestone/components/ui/milestone-page";
import {
  CertificateListTable,
  CertificateListTableFilters,
  useDefaultRltCertificateListRequest,
} from "@/services/backend/rlt/certificates/components/certificate-list-table";

export function CertificatesIndexRoute() {
  const { processId } = useParams();

  const [request, setRequest] = useState(
    useDefaultRltCertificateListRequest(processId!),
  );

  const renderRowLink = useCallback(
    (id: string, children: ReactNode) => <NavLink to={id}>{children}</NavLink>,
    [],
  );

  return (
    <MilestonePage>
      <MilestonePageHeader>
        <MilestonePageTitle>{t("Zertifikate")}</MilestonePageTitle>
      </MilestonePageHeader>
      <MilestonePageContent>
        <div className="grid gap-2">
          <div className="flex justify-between">
            <CertificateListTableFilters
              request={request}
              onRequestChange={setRequest}
            />
            <NewCertificateButton processId={processId!} />
          </div>
          <CertificateListTable
            request={request}
            onRequestChange={setRequest}
            renderRowLink={renderRowLink}
          />
        </div>
      </MilestonePageContent>
    </MilestonePage>
  );
}
